module.exports = __webpack_public_path__ + "img/jiuaishua2.f1a6d931.png";